import { useThemeContext } from "../../../context/ThemeContext";
import { TOKENS } from "../../../hooks/useTheme";

import { CardLabel } from "../CardLabel";
import { Card } from "../Card";
import { Button } from "../../Button/Button";

import styles from "./JsonCard.module.scss";

import { JsonCardProps, JsonValue } from "../types";

interface CodeRowProps {
  rowKey: string;
  value: JsonValue;
}

function CodeRow({ rowKey, value }: CodeRowProps) {
  const theme = useThemeContext();

  return (
    <>
      {"  "}
      <span style={{ color: theme.muted }}>{rowKey}</span>:{" "}
      {Array.isArray(value) ? (
        <>
          [
          {value.map((item, i) => (
            <span key={i}>
              <span style={{ color: TOKENS.kw }}>'{item}'</span>
              {i < value.length - 1 ? ", " : ""}
            </span>
          ))}
          ]
        </>
      ) : (
        <span style={{ color: TOKENS.kw }}>'{value}'</span>
      )}
      ,{"\n"}
    </>
  );
}

export function JsonCard({
  label,
  labelType,
  comment,
  jsonContent,
  hasButton,
  buttonType,
  buttonText,
  buttonOnClick,
}: JsonCardProps) {
  const theme = useThemeContext();

  return (
    <Card theme={theme} className={styles.jsonCard}>
      <CardLabel cardLabelType={labelType} cardLabelText={label} />
      <pre className={styles.codeBlock} style={{ color: theme.fg }}>
        {comment && (
          <>
            <span style={{ color: TOKENS.comment }}>{`// ${comment}`}</span>
            {"\n"}
          </>
        )}
        <span style={{ color: theme.acc }}>const</span>{" "}
        <span style={{ color: TOKENS.fn }}>me</span> = {"{"}
        {"\n"}
        {Object.entries(jsonContent).map(([key, value]) => (
          <CodeRow key={key} rowKey={key} value={value} />
        ))}
        {"}"} <span style={{ color: theme.acc }}>as const</span>;
      </pre>
      <div
        className={styles.jsonCardFooter}
        style={{ borderTopColor: theme.rule, color: theme.muted }}
      >
        {hasButton && (
          <Button
            buttonType={buttonType}
            buttonText={buttonText}
            onClick={() => buttonOnClick?.()}
          />
        )}
      </div>
    </Card>
  );
}
